import { http } from './http';
import { baseURL, verbiEndpoint } from './wpConfig';
import { VerbiAddWinnerResponse, VerbiResponse, VerbiWinnersResponse } from './types';
import { UserCredentials } from './wpAuth';

export const getVerbi = (postId: number): Promise<VerbiResponse> => {
    const endPoint: string = `${baseURL}${verbiEndpoint}/get_verbi?post_id=${postId}`;
    return http.get<VerbiResponse>(endPoint);
};

export const addWinner = (userCredentials: UserCredentials, postId: number, winnerId: number): Promise<VerbiAddWinnerResponse> => {
    const endPoint: string = `${baseURL}${verbiEndpoint}/add_winner?post_id=${postId}&winner_id=${winnerId}`;
    return http.get<VerbiAddWinnerResponse>(endPoint, { auth: userCredentials });
};

export const getWinners = (postId: number): Promise<VerbiWinnersResponse> => {
    const endPoint: string = `${baseURL}${verbiEndpoint}/get_winners?post_id=${postId}`;
    return http.get<VerbiWinnersResponse>(endPoint);
};


